<template>
  <van-actionsheet
    :class="`normal-sheet sheet-${actionFrom}`"
    v-model="showActionSheet"
    @click-overlay="clearActionSheet"
  >
    <div v-if="actionTitle" class="menu-header">
      <div class="has-border-bottom">
        <div class="action-title two-line-ellipsis">{{ actionTitle }}</div>
      </div>
    </div>
    <div v-else-if="actionItem" class="file-list">
      <frequent-item
        v-if="actionFrom === 'frequent'"
        class="has-border-bottom"
        :item="actionItem"
        :hideAction="true"
          :noBorder="true"
        :disableClickStyle="true"
      />
      <file-item
        v-else-if="actionFrom !== 'trash-filter'"
        class="has-border-bottom"
        :item="actionItem"
        :scenario="actionFrom === 'share' ? 'share' : undefined"
        :hideAction="true"
        :noBorder="true"
        :disableClickStyle="true"
      />
    </div>
    <ul class="shrink-wrapper">
      <li
        v-for="(action, idx) of actions"
        :class="['action-item', action.className, action.disabled && 'disabled']"
        :key="action.key"
        @click="action.callback"
      >
        <div :class="['content', idx && 'has-border-top']">
          <i v-if="action.leftIcon" :class="['left-icon', 'iconfont', 'icon-' + action.leftIcon]"/>
          {{action.name}}
          <svg-icon v-if="action.rightIcon" cls="right-icon" :icon="action.rightIcon"/>
        </div>
      </li>
    </ul>
    <div
      v-if="actionFrom !== 'plus' && actionName !== 'share'"
      class="cancel"
      :key="'cancel'"
      @click="clearActionSheet"
    >
      <div class="content">
        {{$t('base.cancel')}}
      </div>
    </div>
  </van-actionsheet>
</template>

<script>
import {i18n} from '@/utils/i18n'
import FileItem from '../file/FileItem'
import FrequentItem from '../file/FrequentItem'

export default {
  name: 'ActionSheet',
  i18n,
  components: {
    FileItem,
    FrequentItem
  },
  props: {
    actions: Array,
    actionItem: null,
    actionFrom: String,
    actionName: String,
    actionTitle: String
  },
  data () {
    return {
      showActionSheet: false
    }
  },
  computed: {
  },
  watch: {
    $route (to, from) {
      this.showActionSheet = !!to.query.actionsheet

      if (this.showActionSheet && !this.actionTitle && this.actionItem && !this.actionItem.id) {
        this.showActionSheet = false
        this.$router.go(-1)
      }
    },
    showActionSheet (val, oldVal) {
      if (!val && oldVal && this.$route.query.actionsheet) {
        this.$router.go(-1)
      }
    }
  },
  methods: {
    clearActionSheet () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="postcss">
@import 'variables';

.van-actionsheet {
  display: flex;
  flex-direction: column;
  max-height: 80%;
  background-color: transparent;

  &.sheet-plus,
  &.sheet-share,
  &.sheet-datetime-picker {
    padding-bottom: 0;
  }

  & li.disabled {
    opacity: 1.0;
    background-color: #fff;
    & .content {
      color: #eaeaea;
    }
  }

  & .van-actionsheet__content {
    display: flex;
    flex-direction: column;

    & > * {
      flex: 0 0 auto;
      box-sizing: border-box
    }

    & .shrink-wrapper {
      flex: 1 1 auto;
      overflow: auto;
      background-color: #fff;
      opacity: 1.0;
    }
  }

  & .file-list {
    padding-left: 20px;
    background-color: #fff;

    & .file-item {
      position: relative;
      padding-right: 15px;
      min-height: 54px;
      border-color: #c5ccd2;
      border-width: 0;

      &::after {
        content: '';
        position: absolute;
        display: block;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 1px;
        background-color: #c5ccd2;
        transform: scaleY(.5);
        transform-origin: 50% 100%;
      }
    }

    & .thumb-icon {
      width: 40px;
      height: 54px;
      justify-content: flex-start;
    }

    & .type-icon {
      width: 26px;
      height: 26px;
    }

    & .item-main {
      min-height: 54px;

      & .item-name {
        font-size: 12px;
        line-height: 18px;
      }
    }
  }

  & li {
    position: relative;
    height: 48px;
    line-height: 48px;
    padding-left: 20px;
    background-color: #fff;
  }

  & .active {
    color: var(--primaryColor)
  }

  & .left-icon {
    margin-right: 10px;
    font-size: 24px;
    color: #9198b2;
    vertical-align: middle
  }

  & .right-icon {
    position: absolute;
    right: 12px;
    top: 18px;
    width: 16px;
    height: 16px;
  }

  & .permanent-delete,
  & .recode-delete {
    color: var(--dangerColor);
  }

  & .cancel {
    background-color: #fff;
    bottom: 0;
    width: 100%;
    height: 48px;
    line-height: 48px;
    margin-top: 6px;
    padding: 0;
    text-align: center;
  }

  & .menu-header {
    background: #fff;
    color: #4b5255;
    font-size: 12px;
    padding-left: 20px;

    & .action-title {
      box-sizing: border-box;
      margin-top: 12px;
      margin-bottom: 12px;
      min-height: 14px;
    }
  }

  & .asc {
    & .right-icon {
      transform: rotate(180deg)
    }
  }

  &.sheet-sort,
  &.sheet-trash-filter {
    text-align: center;

    & li {
      padding-left: 0
    }

    & .content {
      overflow: hidden;
      text-overflow: ellipsis;
      padding: 0 20px;
    }
  }

  &.sheet-sort {
    & .menu-header {
      color: #848484;
      text-align: left;
    }

    & .content {
      padding-left: 0;
      margin-left: 20px;
    }
  }
}
</style>
